export const data = [
  {
    "Title": "Badge of Justice",
    "Issue #": 22,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Baron Weirwulf's Haunted Library",
    "Issue #": 74,
    "Condition": "VF/NM",
    "Website Notes": "Ditko C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Crime and Justice",
    "Issue #": 20,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Crime and Justice",
    "Issue #": 20,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Crime and Justice",
    "Issue #": 26,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "30th Century"
  },
  {
    "Title": "Fightin' Army",
    "Issue #": 12,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Fightin' Army",
    "Issue #": 13,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Foxhole",
    "Issue #": 5,
    "Condition": "G/VG",
    "Website Notes": "Kirby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 375,
    "": "Gilligans"
  },
  {
    "Title": "Gorgo",
    "Issue #": 10,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Rapid City"
  },
  {
    "Title": "Hot Rod Racers",
    "Issue #": 9,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Hot Rod Racers",
    "Issue #": 12,
    "Condition": "NM",
    "Website Notes": "2 avail",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Hot Rods and Racing Cars",
    "Issue #": 27,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Jetsons",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "2025 BCC"
  },
  {
    "Title": "Konga",
    "Issue #": 23,
    "Condition": "VG",
    "Website Notes": "Last Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Monster Hunters",
    "Issue #": 14,
    "Condition": "FN+",
    "Website Notes": "Ditko C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "My Little Margie's Fashion",
    "Issue #": 3,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Mysteries of Unexplored Worlds",
    "Issue #": 19,
    "Condition": "G/VG",
    "Website Notes": "Ditko C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Out of This World",
    "Issue #": 16,
    "Condition": "GD",
    "Website Notes": "Ditko C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Outer Space",
    "Issue #": 17,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Phantom",
    "Issue #": 18,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Phantom",
    "Issue #": 19,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Phantom",
    "Issue #": 20,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Phantom",
    "Issue #": 21,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Phantom",
    "Issue #": 22,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Phantom",
    "Issue #": 23,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Phantom",
    "Issue #": 30,
    "Condition": "VF/Nm",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Phantom",
    "Issue #": 74,
    "Condition": "VF",
    "Website Notes": "Flag C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Phantom",
    "Issue #": "R-06",
    "Condition": "F/VF",
    "Website Notes": "Giveaway",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Ramar of the Jungle",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Reptilicus",
    "Issue #": 1,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "comiclink"
  },
  {
    "Title": "Rookie Cop",
    "Issue #": 27,
    "Condition": "VG/F",
    "Website Notes": "1st Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Brian"
  },
  {
    "Title": "Scooby Doo (Charlton)",
    "Issue #": 3,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Scooby Doo (Charlton)",
    "Issue #": 11,
    "Condition": "VF/VF+",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Six Million Dollar Man",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Space Adventures",
    "Issue #": 6,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Matt"
  },
  {
    "Title": "Space Adventures",
    "Issue #": 35,
    "Condition": "VG/F",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Heroes"
  },
  {
    "Title": "Space Adventures",
    "Issue #": 36,
    "Condition": "FN",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Heroes"
  },
  {
    "Title": "Strange Suspense Stories",
    "Issue #": 19,
    "Condition": "CGC 4.0",
    "Website Notes": "Classic Ditko Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1350,
    "": "George Cumberland"
  },
  {
    "Title": "Tales of the Mysterious Traveler",
    "Issue #": 5,
    "Condition": "VG+",
    "Website Notes": "Ditko C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Vince"
  },
  {
    "Title": "Thing!",
    "Issue #": 4,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Vince"
  },
  {
    "Title": "Timmy the Timid Ghost",
    "Issue #": 17,
    "Condition": "VG",
    "Website Notes": "Blue Bird giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Unusual Tales",
    "Issue #": 9,
    "Condition": "VG",
    "Website Notes": "Ditko C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Vince"
  },
  {
    "Title": "Unusual Tales",
    "Issue #": 25,
    "Condition": "G/VG",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unusual Tales",
    "Issue #": 35,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Unusual Tales",
    "Issue #": 36,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Unusual Tales",
    "Issue #": 36,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Matt"
  },
  {
    "Title": "Unusual Tales",
    "Issue #": 47,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Unusual Tales",
    "Issue #": 48,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  }
];
